import type { PersonaKey } from '../../components/analytics/widgetRegistry.tsx';

/** Query key registry for the self-serve dashboard layout store (Feature 5.3, wave 13). */
const dashboardsRoot = ['dashboards'] as const;

export const dashboardLayoutQueryKeys = {
  all: dashboardsRoot,
  layout: (key: PersonaKey) => [...dashboardsRoot, key, 'layout'] as const,
} as const;
